// Navigation, Kopf- und Fußtexte des niederländischen Bereichs (eigene Datei, damit Kopf/Fuß nicht alle Texte laden).
export const NAV_NL = [
  { to: "/nl/fotoboxen", label: "Fotoboxen" },
  { to: "/nl/kreulbooth", label: "Software" },
  { to: "/nl/waarom-wij", label: "Waarom wij" },
  { to: "/nl/faq", label: "FAQ" },
  { to: "/nl/contact", label: "Contact" },
];

export const HEADER_NL = {
  home: "/nl",
  contactPath: "/nl/contact",
  contact: "Advies",
  quote: "Offerte aanvragen",
  languages: "Taal",
};

export const FOOTER_NL = {
  testid: "site-footer-nl",
  tagline: "Specialist in professionele fotoboxen, gevestigd in Bottrop (Ruhrgebied, Duitsland). Levering in Nederland en België.",
  whatsappHref: "https://wa.me/4915678575025?text=Hello%2C%20I%20am%20interested%20in%20buying%20a%20photo%20booth%20and%20have%20a%20question.",
  columns: [
    { title: "Producten", links: [
      { to: "/nl/fotoboxen", label: "Alle modellen" },
      { to: "/nl/fotoboxen?cat=fotoboxen", label: "Fotoboxen" },
      { to: "/nl/fotoboxen?cat=fotospiegel", label: "Magic mirrors en fotospiegels" },
      { to: "/nl/fotoboxen?cat=spezial", label: "360° en speciale systemen" },
      { to: "/nl/kreulbooth", label: "KreulBooth software" },
    ] },
    { title: "Levering", links: [
      { to: "/nl/fotobox-kopen/nederland", label: "Fotobox kopen in Nederland" },
      { to: "/nl/fotobox-kopen/belgie", label: "Fotobox kopen in België" },
      { to: "/nl/waarom-wij", label: "Waarom wij" },
      { to: "/nl/faq", label: "Veelgestelde vragen" },
      { to: "/nl/contact", label: "Contact en offerte" },
      { to: "/", label: "Duitse website (Deutsch)" },
    ] },
  ],
  contactTitle: "Contact",
  address: ["Kreul Media Group", "Im Fuhlenbrock 113", "46242 Bottrop, Duitsland"],
  copyright: "fotoboxverkauf.de: Kreul Media Group, Duitsland. Juridische documenten zijn beschikbaar in het Duits.",
  legal: [
    { to: "/impressum", label: "Colofon (Impressum)" },
    { to: "/datenschutz", label: "Privacybeleid" },
    { to: "/agb", label: "Algemene voorwaarden" },
    { to: "/widerrufsbelehrung", label: "Herroepingsrecht" },
    { to: "/nl/opzeggen", label: "Contracten hier opzeggen" },
  ],
  cookies: "Cookie-instellingen",
};
